export default "__VITE_ASSET__dca57439__"